export default "__VITE_ASSET__B$jm5Me2__"